import { observer } from 'mobx-react';
import { useStore } from 'app/context';
import { AkumaPrimeSchema, AgtAkumaPrimeKwVM, AkumaPrimeType } from 'app/stores/ui/agt.akumaprime.ui.store';
import { AkumaPrimeHorizontalBarChart } from './AkumaPrimeBarChart';
import { useEffect, useState } from 'react';
import { AkumaPrimeListeAgt } from './AkumaPrimeListe';
import { runInAction } from 'mobx';
import { WeekRangePicker } from 'app/components/common/DatePickers';
import { CheckboxControl } from 'app/components/common/CheckboxControl';
import { AkumaPrimeSankeyChart } from './AkumaPrimeSankeyChart';
import { AkumaPrimeBnrOverview } from './AkumaPrimeBnrOverview';


export const AkumaPrimeOptions = observer(() => {
	const { agtAkumaPrimeUiStore, session } = useStore();

	const onMinChange = (value: number) => {
		runInAction(() => {
			agtAkumaPrimeUiStore.minKwCurrent = value;
		});
	};

	const onMaxChange = (value: number) => {
		runInAction(() => {
			agtAkumaPrimeUiStore.maxKwCurrent = value;
		});
	};

	const toggleShowGraphs = () => {
		runInAction(() => {
			agtAkumaPrimeUiStore.showGraphs = !agtAkumaPrimeUiStore.showGraphs;
		});
	};

	return (
		<div className="grid is-col-auto align-center justify-start pad-1rem">
			<WeekRangePicker
				minValue={agtAkumaPrimeUiStore.minKw}
				maxValue={agtAkumaPrimeUiStore.maxKw}
				opts={agtAkumaPrimeUiStore.kwsOpts}
				onMinChange={onMinChange}
				onMaxChange={onMaxChange}
				queryParam="kw"
			/>
			{session.isAdmin && <CheckboxControl label="Balken anzeigen" name="tracking" value={agtAkumaPrimeUiStore.showGraphs} onChange={toggleShowGraphs} />}
		</div>
	);
});
